module.exports = __webpack_public_path__ + "img/1.70595165.png";